import { motion } from "framer-motion";

export const HelcooLogo = ({ size = 60, animated = true, showBadge = true }) => {
  return (
    <div className="relative inline-block">
      {/* Main Logo Container - CIRCULAR */}
      <motion.div 
        className="relative rounded-full overflow-hidden bg-primary shadow-lg"
        style={{ width: size, height: size }}
        whileHover={animated ? { scale: 1.05, rotate: 3 } : {}}
        transition={{ type: "spring", stiffness: 300 }}
      >
        {/* Animated Background Ring */}
        <svg 
          className="absolute inset-0" 
          width={size} 
          height={size} 
          viewBox="0 0 100 100"
        >
          {/* Outer decorative ring */}
          <circle 
            cx="50" cy="50" r="46" 
            fill="none" 
            className="stroke-primary-foreground"
            strokeWidth="1"
            opacity="0.2"
          />
          
          {/* Animated dashed ring */}
          {animated && (
            <circle 
              cx="50" cy="50" r="44" 
              fill="none" 
              className="stroke-primary-foreground"
              strokeWidth="1.5" 
              strokeDasharray="8 12"
              opacity="0.3"
            >
              <animateTransform 
                attributeName="transform" 
                type="rotate" 
                from="0 50 50" 
                to="360 50 50" 
                dur="20s" 
                repeatCount="indefinite" 
              />
            </circle>
          )}
        </svg>

        {/* H Letter - Centered */}
        <svg 
          className="absolute inset-0 flex items-center justify-center"
          width={size} 
          height={size} 
          viewBox="0 0 100 100"
        >
          <g className="fill-primary-foreground">
            {/* Left vertical bar */}
            <rect x="25" y="25" width="14" height="50" rx="4" />
            {/* Right vertical bar */}
            <rect x="61" y="25" width="14" height="50" rx="4" />
            {/* Horizontal connector */}
            <rect x="25" y="44" width="50" height="12" rx="4" />
          </g>
        </svg>
      </motion.div>
      
      {/* AI Badge */}
      {showBadge && (
        <motion.span 
          className="absolute -top-1.5 -right-1.5 font-bold rounded-full shadow-md z-20 bg-background text-foreground border border-border"
          style={{ 
            fontSize: Math.max(size * 0.15, 10),
            padding: `${Math.max(size * 0.04, 3)}px ${Math.max(size * 0.08, 6)}px`,
          }}
          animate={animated ? { y: [0, -3, 0] } : {}}
          transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
        >
          AI
        </motion.span>
      )}
    </div>
  );
};

// Small circular logo for buttons
export const HelcooMiniLogo = ({ size = 20, className = "" }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100"
      className={className}
    >
      <g className="fill-current">
        {/* Left vertical bar */}
        <rect x="25" y="25" width="14" height="50" rx="4" />
        {/* Right vertical bar */}
        <rect x="61" y="25" width="14" height="50" rx="4" />
        {/* Horizontal connector */}
        <rect x="25" y="44" width="50" height="12" rx="4" />
      </g>
    </svg>
  );
};

// Full Logo with Text
export const HelcooLogoFull = ({ size = 60, animated = true }) => {
  return (
    <div className="flex items-center gap-4">
      <HelcooLogo size={size} animated={animated} showBadge={true} />
      <span
        className="font-bold tracking-tight text-foreground"
        style={{ fontSize: size * 0.5 }}
      >
        HELCOO
      </span>
    </div>
  );
};

// Small Icon Version
export const HelcooIcon = ({ size = 40 }) => {
  return <HelcooLogo size={size} animated={false} showBadge={false} />;
};

export default HelcooLogo;
